import PropTypes from 'prop-types';
import breakPoints from 'helpers/Styles';
import { useState, useRef, useMemo, useEffect } from 'react';

const CategoryFourColumns = ({ categories, handleMainCategory }) => {
  const { items, primary } = categories;

  const [selectedOption, setSelectedOption] = useState(items.category_tag);

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
    const selectedElement = document.getElementById(selected);
  
    if (selected) {
      const activeElement = document.querySelectorAll('.active');
      activeElement.forEach((element) => element.classList.remove('active'));
      selectedElement.classList.add('active');
      handleMainCategory(selected);
    }
  };
  
  return (
    <>
    <div className="category-section">
      <p className="header">{primary.title1}</p>
        <div style={{overflow: 'auto'}}>
          <div className="category-container">
            {items.map((category, i) => (
              <div key={i} className={i === 0 ? 'category active' : 'category'} id={category.category_tag[0].text} onClick={() => handleSelectChange(category.category_tag[0].text)}>
                <h3 className="category-title">{category.category_tag[0].text}</h3>
                <div className="category-img-container">
                  <img draggable="false"  className="category-img" src={category.category_image.url} />
                </div>
                <div className="category-description-container">
                  <p className="category-description">{category.category_description[0].text}</p>
                </div>
                <button className="category-btn">View Products</button>
              </div>
            ))}
          </div>
        </div>
    </div>

      <style jsx>
        {`
          .category-section {
            padding-bottom: 4%;
            border-bottom: 1px solid #3A3A3A;
          }
          .header {
            text-align: center;
            font-size: 32px;
            font-family: 'Roboto-Medium';
            font-weight: 700;
            text-transform: uppercase;
            padding-bottom: 5px;
          }
          .category-container {
            display: flex;
            align-items: center;
            width: fit-content;
          }
          .category {
            background-color: #3d403d;
            width: 316px;
            margin-right: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            border-radius: 2px;
            background-image: linear-gradient(#6B7287, #2E2D33, #212026);
            height: 450px;
            cursor: pointer;
          }
          .category-title {
            text-transform: uppercase;
            font-family: 'big_noodle_titling';
            font-size: 30px;
            margin-top: 5%;
          }
          .category-img-container {
            width: 200px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .category-img {
            width: 100%;
            height: 100%;
          }
          .category-description-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90%;
            height: 50px;
            margin-top: 2%;
            margin-bottom: 6%;
          }
          .category-description {
            font-size: 11px;
            font-family: 'Roboto-Normal';
            width: 80%;
            text-align: center;
            margin: 0;
          }
          .category-btn {
            margin-top: 2%;
            margin-bottom: 8%;
            background: transparent;
            box-shadow: none;
            border: 1px solid #FCFCFC;
            padding: 15px 25px 15px 25px;
            text-transform: capitalize;
            color: #FCFCFC;
            font-family: 'Roboto-Medium';
            font-weight: 700;
            letter-spacing: 1px;
            border-radius: 2px;
            font-size: 13px;
          }
          .active {
            border: 3px solid white;
          }
          @media (max-width: ${breakPoints.medium}) {
            .category-container {
              flex-direction: row;
              justify-content: normal;
              overflow: auto;
              width: auto;
            }
            .category {
              width: 100%;
              margin-right: 5%;
              height: 360px;
            }
            .category-img-container {
              width: 150px;
              height: 150px;
            }
            .category-description {
              width: 250px;
            }
            .category-title {
              margin-bottom: 5%;
            }
            .category-description {
              font-size: 10px;
            }
            ::-webkit-scrollbar {
              -webkit-appearance: none;
            }
            .header {
              font-size: 20px;
            }
          }
        `}
      </style>
    </>
  );
};

CategoryFourColumns.propTypes = {
  categories: PropTypes.object,
};

CategoryFourColumns.defaultProps = {
  categories: {}
};

export default CategoryFourColumns;